import { NgModule } from "@angular/core";
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TruncatedTextComponent } from "./truncated-text.component";

@NgModule({
  declarations: [TruncatedTextComponent],
  imports: [
    MatTooltipModule,
  ],
  exports: [TruncatedTextComponent]
})
export class InovaCoreTruncatedTextModule {
}